/* eslint-disable */

const isGSL =
    window.location.hostname.toLowerCase().endsWith("gslcustomer.com") ||
    process.env.REACT_APP_IS_GSL === "true";

//Test/Staging/Prod (these values will be replaced by Octopus, comment out for manual or local deploy)
const API_URI = process.env.REACT_APP_API_URI as string;
const GSL_API_URI = process.env.REACT_APP_GSL_API_URI as string;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
const ISSUER = isGSL
    ? (process.env.REACT_APP_ISSUER_GSL as string)
    : (process.env.REACT_APP_ISSUER as string);
const RECAPTCHAV2_KEY = process.env.REACT_APP_RECAPTCHAV2_KEY as string;
const RECAPTCHAV3_KEY = process.env.REACT_APP_RECAPTCHAV3_KEY as string;
const ADYEN_ENV = process.env.REACT_APP_ADYEN_ENV as string;
const ADYEN_KEY = process.env.REACT_APP_ADYEN_KEY as string;
const TIMEOUT_MIN = process.env.REACT_APP_TIMEOUT_MIN as string;
const DOCUSIGN_URI = isGSL
    ? (process.env.REACT_APP_GSL_DOCUSIGN_URI as string)
    : (process.env.REACT_APP_DOCUSIGN_URI as string);
const PAPER_COMPANY_CDN = process.env.REACT_APP_PAPER_COMPANY_CDN as string;

let OKTA_TESTING_DISABLEHTTPSCHECK = false;
const BASENAME = "";
const REDIRECT_URI = `${window.location.origin}${BASENAME}/login/callback`;

/* eslint-enable */
const config = {
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: REDIRECT_URI,
        scopes: ["openid", "profile", "email"],
        pkce: true,
        disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK
    },
    adyen: {
        environment: ADYEN_ENV,
        clientKey: ADYEN_KEY
    },
    resourceServer: {
        apiUrl: isGSL ? GSL_API_URI : API_URI
    },
    app: {
        basename: BASENAME,
        recaptchav2Key: RECAPTCHAV2_KEY,
        recaptchav3Key: RECAPTCHAV3_KEY,
        hideForNonDev: false,
        userTimeout: TIMEOUT_MIN,
        docuSignUri: DOCUSIGN_URI,
        paperCompanyCdn: PAPER_COMPANY_CDN,
        isGSL: isGSL
    }
};

export { config };
